export default "__VITE_ASSET__mpE0wInP__"